import { Role } from '@/client/roles';
import { SystemRoles } from '@/client/users';
import { UserOrigin } from '@/client/users/types/origins.enum';
import { TranslationFunctionType } from '@/common/types';

export const allRolesOptions = (t: TranslationFunctionType) => [
  {
    label: t('roles.developer'),
    value: SystemRoles.DEVELOPER,
  },
  {
    label: t('roles.superAdmin'),
    value: SystemRoles.SUPER_ADMIN,
  },
  {
    label: t('roles.multiAccountAdmin'),
    value: SystemRoles.MULTIPLE_ACCOUNTS_ADMIN,
  },
  {
    label: t('roles.admin'),
    value: SystemRoles.ADMIN,
  },
  {
    label: t('roles.learner'),
    value: SystemRoles.LEARNER,
  },
  {
    label: t('roles.commercialAdmin'),
    value: SystemRoles.COMMERCIAL_ADMIN,
  },
];

export const systemRoleOptions = (t: TranslationFunctionType) => [
  {
    label: t('roles.developer'),
    value: [SystemRoles.DEVELOPER],
  },
  {
    label: t('roles.superAdmin'),
    value: [SystemRoles.SUPER_ADMIN],
  },
  {
    label: t('roles.commercialAdmin'),
    value: [SystemRoles.COMMERCIAL_ADMIN],
  },
  {
    label: t('roles.admin'),
    value: [SystemRoles.ADMIN],
  },
  {
    label: t('roles.learner'),
    value: [SystemRoles.LEARNER],
  },
];

export const notSystemRoleOptions = (t: TranslationFunctionType) => [
  {
    label: t('roles.admin'),
    value: [SystemRoles.ADMIN, SystemRoles.MULTIPLE_ACCOUNTS_ADMIN],
  },
  {
    label: t('roles.learner'),
    value: [SystemRoles.LEARNER],
  },
];

export const userOriginOptions = (t: TranslationFunctionType) => [
  { label: t('user.type.manual'), value: UserOrigin.MANUAL },
  { label: t('user.type.azure-ad'), value: UserOrigin.AZURE_AD },
  {
    label: t('user.type.google-workspace'),
    value: UserOrigin.GOOGLE_WORKSPACE,
  },
];

export const loginMethodOptions = (t: TranslationFunctionType) => [
  { label: t('user.loginMethod.sso'), value: UserOrigin.AZURE_AD },
  { label: t('user.loginMethod.manual'), value: UserOrigin.MANUAL },
];

export const roleTranslations = (role: Role, t: TranslationFunctionType) => {
  // Using switch case for translation
  switch (role.code) {
    case SystemRoles.MULTIPLE_ACCOUNTS_ADMIN:
      return t('roles.multiAccountAdmin');
    case SystemRoles.DEVELOPER:
      return t('roles.developer');
    case SystemRoles.SUPER_ADMIN:
      return t('roles.superAdmin');
    case SystemRoles.ADMIN:
      return t('roles.admin');
    case SystemRoles.LEARNER:
      return t('roles.learner');
    case SystemRoles.COMMERCIAL_ADMIN:
      return t('roles.commercialAdmin');
    default:
      return role?.name;
  }
};

export const roleTranslationsByCode = (
  roleCode: SystemRoles,
  t: TranslationFunctionType,
) => {
  // Using switch case for translation
  switch (roleCode) {
    case SystemRoles.MULTIPLE_ACCOUNTS_ADMIN:
      return t('roles.multiAccountAdmin');
    case SystemRoles.DEVELOPER:
      return t('roles.developer');
    case SystemRoles.SUPER_ADMIN:
      return t('roles.superAdmin');
    case SystemRoles.ADMIN:
      return t('roles.admin');
    case SystemRoles.LEARNER:
      return t('roles.learner');
    case SystemRoles.COMMERCIAL_ADMIN:
      return t('roles.commercialAdmin');
    default:
      return roleCode;
  }
};
